import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MaskLines, Eyebrow } from "./Reveal";

export const PageHero = ({ eyebrow, lines, text, image, alt, children, testId = "page-hero" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);
  return (
    <section ref={ref} data-testid={testId} className="relative bg-paper pt-32 pb-16 sm:pt-40 lg:pb-24">
      <div className="container-x grid items-end gap-12 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Eyebrow>{eyebrow}</Eyebrow>
          <MaskLines lines={lines} testId={`${testId}-title`} className="mt-6 font-display text-[2.6rem] font-semibold leading-[0.95] tracking-tighter text-forest sm:text-6xl lg:text-7xl" />
          <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.6, duration: 0.8 }} className="mt-8 max-w-xl text-base leading-relaxed text-ink/80 md:text-lg">{text}</motion.p>
          {children}
        </div>
        <motion.div initial={{ clipPath: "inset(100% 0% 0% 0% round 2rem)" }} animate={{ clipPath: "inset(0% 0% 0% 0% round 2rem)" }}
          transition={{ duration: 1.3, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="relative aspect-[4/5] max-h-[70vh] w-full overflow-hidden rounded-[2rem] lg:col-span-5">
          <motion.img style={{ y }} src={image} alt={alt} className="absolute inset-0 h-[115%] w-full object-cover" />
        </motion.div>
      </div>
    </section>
  );
};
